import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useAssessmentTypeReducer = () =>
  useSelector((state: ApplicationState) => state.assessmentType);

